import React from "react";
import Slider from "react-slick";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom next" onClick={onClick}>
      <img
        src="/assets/slider/next-arrow.svg"
        className="xl:h-auto lg:h-[77px] object-cover h-[80px]"
        alt=""
      />
    </div>
  );
};

// Custom Prev Arrow
const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="custom prev" onClick={onClick}>
      <img
        src="/assets/slider/prev-arrow.svg"
        className="xl:h-auto lg:h-[77px] object-cover h-[80px]"
        alt=""
      />
    </div>
  );
};

function TestSlider({ data = [] }) {
  const settings = {
    customPaging: function (i) {
      return (
        <a>
          <img
            src={data[i]?.image || "/assets/slider/img1.png"}
            // src={`/assets/slider/img${i + 1}.png`}
            className="lg:w-[64px] w-full md:h-[95px] h-[75px] object-cover"
            alt="img1"
          />
        </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };
  return (
    <>
      <Slider {...settings}>
        {data.map((testimonial, idx) => (
          <div key={testimonial._id || idx}>
            <div className="max-w-[830px] mx-auto w-full">
              <div className="flex xl:flex-row lg:flex-row flex-col xl:items-end lg:items-end md:items-center">
                {/* IMAGE + NAME SECTION */}
                <div className="w-full md:max-w-[340px] max-w-max mx-auto">
                  <img
                    src={testimonial.image}
                    className="md:w-[340px] w-full h-[446px] object-cover"
                    alt={testimonial.name}
                  />
                  <div className="bg-[#6953A3] px-[28px] py-[24px]">
                    <h6 className="font-[800] text-[28px] font-sans text-[#FFFFFF] pb-[6px]">
                      {testimonial.name}
                    </h6>
                    <p className="font-[400] text-[16px] font-sans text-[#FFFFFF]">
                      {testimonial.designation}
                    </p>
                  </div>
                </div>

                {/* MESSAGE SECTION */}
                <div className="w-full md:max-w-[688px]">
                  <div className="border-[1px] bg-[#FFFFFF] lg:p-[40px] p-[20px] border-[#6953A3] h-[256px] overflow-y-scroll">
                    <img src="/assets/a/item2.svg" alt="" />
                    <p className="pt-[10px] font-sans font-[400] lg:text-[22px] text-[18px] lg:leading-[34px] leading-[24px] text-[#6953A3]">
                      “{testimonial.message}”
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        {/* <div>
                    <div className='max-w-[830px] mx-auto w-full'>
                        <div className="flex xl:flex-row lg:flex-row flex-col xl:items-end lg:items-end md:items-center">
                            <div className='w-full md:max-w-[340px] max-w-max mx-auto'>
                                <img src="/assets/slider/img1.png" className='md:w-[340px] w-full h-[446px]' alt="" />
                                <div className='bg-[#6953A3] px-[28px] py-[24px]'>
                                    <h6 className="font-[800] text-[28px] font-sans text-[#FFFFFF] pb-[6px]">Lakshmi Kanth Sane</h6>
                                    <p className="font-[400] text-[16px] font-sans text-[#FFFFFF]">Instructor</p>
                                </div>
                            </div>
                            <div className='w-full md:max-w-[688px]'>
                                <div className='border-[1px] bg-[#FFFFFF] lg:p-[40px] p-[20px] border-[#6953A3] h-[256px] overflow-y-scroll'>
                                    <img src="/assets/a/item2.svg" alt="" />
                                    <p className="pt-[10px] font-sans font-[400] lg:text-[22px] text-[18px] lg:leading-[34px] leading-[24px] text-[#6953A3]">We’ve been working with Gisul for over 3 Months, and I couldn’t be happier with their service. During our recent training received for freshers that we hired from Campus, Gisul met our expectations with their attention to detail and responsiveness. Their expertise not only streamlined our training needs but also saved us time and money. I highly recommend Gisul to anyone looking for any kind of training. They are a reliable partner, and I look forward to continuing our work together.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='max-w-[830px] mx-auto w-full'>
                        <div className="flex xl:flex-row lg:flex-row flex-col xl:items-end lg:items-end md:items-center">
                            <div className='w-full md:max-w-[340px] max-w-max mx-auto'>
                                <img src="/assets/slider/img2.png" className='md:w-[340px] w-full h-[446px]' alt="" />
                                <div className='bg-[#6953A3] px-[28px] py-[24px]'>
                                    <h6 className="font-[800] text-[28px] font-sans text-[#FFFFFF] pb-[6px]">Vaibhav T</h6>
                                    <p className="font-[400] text-[16px] font-sans text-[#FFFFFF]">Instructor</p>
                                </div>
                            </div>
                            <div className='w-full md:max-w-[688px]'>
                                <div className='border-[1px] bg-[#FFFFFF] lg:p-[40px] p-[20px] border-[#6953A3] h-[256px] overflow-y-scroll'>
                                    <img src="/assets/a/item2.svg" alt="" />
                                    <p className="pt-[10px] font-sans font-[400] lg:text-[22px] text-[18px] lg:leading-[34px] leading-[24px] text-[#6953A3]">I would like to thank GISUL for understanding our requirements and connecting us with the quality trainers who met our expectations always. GISUL always been prompt in responding to our needs. I would say they value their customers highly and customer satisfaction seems to be on top of their list. I have got the feedback from the participants regarding the data analytics workshop, and it was very good.Thank you so much for organizing such a wonderful workshop for us.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='max-w-[830px] mx-auto w-full'>
                        <div className="flex xl:flex-row lg:flex-row flex-col xl:items-end lg:items-end md:items-center">
                            <div className='w-full md:max-w-[340px] max-w-max mx-auto'>
                                <img src="/assets/slider/img3.png" className='md:w-[340px] w-full h-[446px]' alt="" />
                                <div className='bg-[#6953A3] px-[28px] py-[24px]'>
                                    <h6 className="font-[800] text-[28px] font-sans text-[#FFFFFF] pb-[6px]">Lakshmi Kanth Sane</h6>
                                    <p className="font-[400] text-[16px] font-sans text-[#FFFFFF]">Instructor</p>
                                </div>
                            </div>
                            <div className='w-full md:max-w-[688px]'>
                                <div className='border-[1px] bg-[#FFFFFF] lg:p-[40px] p-[20px] border-[#6953A3] h-[256px] overflow-y-scroll'>
                                    <img src="/assets/a/item2.svg" alt="" />
                                    <p className="pt-[10px] font-sans font-[400] lg:text-[22px] text-[18px] lg:leading-[34px] leading-[24px] text-[#6953A3]">Gisul and their training work I highly recommend. Gisul has held numerous training courses for us here in South Africa and has also consulted on Pentaho ETL projects and continues to do so. Sahil has a great work ethic, is a team player and has remained a vital member of our extended team. We would therefore highly recommend Gisul for any training requirements you might have.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
      </Slider>
    </>
  );
}

export default TestSlider;
